import React from "react";
import styles from "./ModalFooterContent.module.scss";
import {
  ButtonSize,
  ButtonType,
  CommonButtonTexts,
} from "../../enums/ButtonAttributesEnums";
import ConditionalRender from "../ConditionalRender";
import { FooterType } from "../../enums/ModalEnums";
import TNButton from "../TNButton";

interface ModalFooterContentProps {
  messageHeader: string;
  messageContent: string;
  footerType: string;
  okButtonAction: () => void;
  cancelButtonAction: () => void;
}

const ModalFooterContent = ({
  messageHeader,
  messageContent,
  footerType,
  okButtonAction,
  cancelButtonAction,
}: ModalFooterContentProps) => {
  return (
    <div className={styles.modalFooter}>
      <div className={styles.notes}>
        <span className={styles.noteHeader}>{messageHeader}</span>
        &nbsp;
        <span>{messageContent}</span>
      </div>
      <div>
        <ConditionalRender visible={footerType === FooterType.STANDARD_TWO}>
          <TNButton
            type={ButtonType.DEFAULT}
            size={ButtonSize.MEDIUM}
            onClick={cancelButtonAction}
            text={CommonButtonTexts.CANCEL}
          />
          <TNButton
            type={ButtonType.PRIMARY}
            size={ButtonSize.MEDIUM}
            onClick={okButtonAction}
            text={CommonButtonTexts.CONFIRM}
          />
        </ConditionalRender>
      </div>
    </div>
  );
};

export default ModalFooterContent;
